import { Checkbox, FormControl, FormControlLabel, InputLabel } from '@mui/material';
import { Permission } from '@procureai/permissions';
import { usePermissions } from '@procureai/permissions-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';

import { I18nNamespace } from '~/common/types';
import { AstronautUserAutocomplete } from '~/components/AstronautUserAutocomplete';
import { useResponsibleUsers } from '~/components/ResponsibleUsersProvider';

export const ResponsibleUsersSelect = () => {
  const { t } = useTranslation(I18nNamespace.common, { keyPrefix: 'ResponsibleUsersSelect' });
  const { users, setUsers } = useResponsibleUsers();
  const { user } = useAuth();
  const { hasPermission } = usePermissions();
  const [isMyself, setIsMyself] = useState(false);

  return (
    <FormControl sx={{ m: 1, minWidth: 250 }} size="small">
      {hasPermission(Permission.BaseGeneralFilterByUsers) ? (
        <>
          {!users?.length && <InputLabel id="responsible-users-select-label">{t('responsibleUsers')}</InputLabel>}
          <AstronautUserAutocomplete
            multiple
            fullWidth
            size="small"
            value={users ?? []}
            hasEmptyOption
            onChange={(value) => setUsers(value ?? [])}
            translationPrefix="ResponsibleUsersSelect.options"
          />
        </>
      ) : (
        <FormControlLabel
          label={t('options.ME')}
          control={
            <Checkbox
              checked={isMyself}
              onChange={(event) => {
                setUsers(event.target.checked && user ? [user.profile.sub] : []);
                setIsMyself(event.target.checked);
              }}
            />
          }
        />
      )}
    </FormControl>
  );
};
